// src/modules/ga4/cardModalDataAttributeSetter.js

export function initCardModalDataAttributeSetter() {
 // モーダルを取得
 const modal = document.getElementById("item_card_modal");
 const baseCategory = "item_card_modal";

 if (!modal) {
  // モーダルが存在しない場合は何もしない（`flow-chart`など、画面によっては存在しないため）
  return;
 }

 // 初期のdata-gtm-category属性を空に設定
 modal.setAttribute("data-gtm-category", "");

 // クリックイベントのデリゲーションをキャプチャフェーズで設定
 document.body.addEventListener(
  "click",
  function (event) {
   // クリックされた要素から指定のボタンを探す
   const button = event.target.closest(".p-card__modal-open-button");
   if (button) {
    let element = event.target;

    // data-gtm-category属性を持つ親要素を探す（クリックされた要素から）
    const categoryElement = element.closest("[data-gtm-category]");

    // data-gtm-category属性の値を取得、存在しない場合は"unknown"
    const gtmCategory = categoryElement ? categoryElement.getAttribute("data-gtm-category") : "unknown";

    // モーダルのdata-gtm-category属性を更新
    modal.setAttribute("data-gtm-category", `${baseCategory}_${gtmCategory}`);
   }
  },
  true
 ); // ← キャプチャフェーズを指定
}
